export default "__VITE_ASSET__BuyFFWz8__"